import { createReducer, on } from '@ngrx/store';

import { FeatureFlagsActions } from './feature-flags.actions';
import { FeatureFlagsState, initialFeatureFlagsState } from './feature-flags.state';

export const featureFlagsReducer = createReducer(
  initialFeatureFlagsState,
  on(
    FeatureFlagsActions.loadActiveFeatures,
    (state): FeatureFlagsState => ({
      ...state,
      loading: true,
      error: null
    })
  ),
  on(
    FeatureFlagsActions.loadActiveFeaturesSuccess,
    (state, { activeFeatures, dataSpaceId }): FeatureFlagsState => ({
      ...state,
      activeFeatures,
      dataSpaceId,
      loading: false,
      loaded: true,
      error: null
    })
  ),
  on(
    FeatureFlagsActions.loadActiveFeaturesFailure,
    (state, { error }): FeatureFlagsState => ({
      ...state,
      loading: false,
      error
    })
  )
);
